import type { LicenceTierId, TurnkeyStatus } from "@/types";

export interface StatusMeta {
  label: string;
  colour: string;
  /** Sort weight — available stock first, sold out last. */
  order: number;
}

export const STATUS_META: Record<TurnkeyStatus, StatusMeta> = {
  "ready-to-sell": { label: "Ready to Sell", colour: "#2e5a32", order: 0 },
  "under-development": { label: "Under Development", colour: "#9a5620", order: 1 },
  "coming-soon": { label: "Coming Soon", colour: "#8a6a1f", order: 2 },
  planning: { label: "Planning", colour: "#4a5b8c", order: 3 },
  "sold-out": { label: "Sold Out", colour: "#6b7a70", order: 4 },
};

export const STATUS_ORDER: TurnkeyStatus[] = [
  "ready-to-sell",
  "under-development",
  "coming-soon",
  "planning",
  "sold-out",
];

export type CtaIntent = "register" | "details" | "visit" | "similar";

export const CTA_BY_STATUS: Record<TurnkeyStatus, { label: string; intent: CtaIntent }> = {
  "coming-soon": { label: "Register Interest", intent: "register" },
  planning: { label: "Register Interest", intent: "register" },
  "under-development": { label: "Request Details", intent: "details" },
  "ready-to-sell": { label: "Schedule a Visit", intent: "visit" },
  "sold-out": { label: "Explore Similar Projects", intent: "similar" },
};

export const ENQUIRY_TYPES = [
  "New Project",
  "Architecture",
  "Civil Engineering",
  "Turn-Key Project",
  "Property Enquiry",
  "Floor Plan Licence",
  "Careers",
  "Partnership",
  "General Enquiry",
] as const;

export const PROJECT_TYPE_OPTIONS = [
  "Residential",
  "Commercial",
  "Institutional",
  "Industrial",
  "Renovation / Restoration",
  "Interior fit-out",
] as const;

export const BUDGET_BANDS = [
  "Under ₹50 L",
  "₹50 L – 2 Cr",
  "₹2 – 10 Cr",
  "₹10 Cr+",
  "Not decided",
] as const;

/** Zoom ceiling applied to an unlicensed floor plan preview. */
export const PREVIEW_MAX_ZOOM = 1.3;
export const VIEWER_MAX_ZOOM = 4;

export const LICENCE_ORDER: LicenceTierId[] = ["personal", "commercial", "extended"];

export const CONTACT = {
  phone: "+91 124 456 7890",
  phoneHref: "tel:+911244567890",
  email: "hello@indraprastha.design",
  salesEmail: "sales@indraprastha.design",
  careersEmail: "careers@indraprastha.design",
  address: "4th Floor, Sector 44 Business Centre, Gurugram, Haryana 122003",
} as const;
